const DEFAULT_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/g;

// eslint-disable-next-line import/prefer-default-export
export function isPasswordValid(value, regex = DEFAULT_REGEX) {
  if (!value) {
    return false;
  }
  return !!value.match(regex);
}
